import { render, staticRenderFns } from "./EditVideoRecorderConfiguration.vue?vue&type=template&id=229e8715&"
import script from "./EditVideoRecorderConfiguration.vue?vue&type=script&lang=js&"
export * from "./EditVideoRecorderConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports